import type { StoreAnalytics } from "@/types/models";

interface TopProductsTableProps {
  topViewedProducts: StoreAnalytics["topViewedProducts"];
  topClickedProducts: StoreAnalytics["topClickedProducts"];
}

type ProductRow = StoreAnalytics["topViewedProducts"][number];

function ProductTable({
  title,
  rows,
  emptyMessage,
}: {
  title: string;
  rows: ProductRow[];
  emptyMessage: string;
}) {
  return (
    <section className="border border-primary-200 dark:border-primary-800 bg-white dark:bg-primary-900 p-8">
      <h2 className="text-xl font-light tracking-tight text-primary-900 dark:text-white mb-6">
        {title}
      </h2>

      {rows.length === 0 ? (
        <p className="text-sm font-light text-primary-600 dark:text-primary-400">{emptyMessage}</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-primary-200 dark:border-primary-800">
                <th className="pb-3 text-xs font-light tracking-widest uppercase text-primary-600 dark:text-primary-400">
                  Produto
                </th>
                <th className="pb-3 text-xs font-light tracking-widest uppercase text-primary-600 dark:text-primary-400 text-right">
                  Visualizações
                </th>
                <th className="pb-3 text-xs font-light tracking-widest uppercase text-primary-600 dark:text-primary-400 text-right">
                  Cliques WhatsApp
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr
                  key={row.product.id}
                  className="border-b border-primary-100 dark:border-primary-800 last:border-0"
                >
                  <td className="py-4 text-sm font-light text-primary-900 dark:text-white">
                    {row.product.name}
                  </td>
                  <td className="py-4 text-sm font-light text-primary-800 dark:text-white text-right">
                    {row.viewCount.toLocaleString("pt-BR")}
                  </td>
                  <td className="py-4 text-sm font-light text-primary-800 dark:text-white text-right">
                    {row.clickCount.toLocaleString("pt-BR")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

export default function TopProductsTable({
  topViewedProducts,
  topClickedProducts,
}: TopProductsTableProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <ProductTable
        title="Mais visualizados"
        rows={topViewedProducts}
        emptyMessage="Nenhum produto visualizado no período."
      />
      <ProductTable
        title="Mais clicados no WhatsApp"
        rows={topClickedProducts}
        emptyMessage="Nenhum clique no WhatsApp no período."
      />
    </div>
  );
}
